<!--
 * @Descripttion:
 * @version:
 * @Author: 杨海波
 * @Date: 2021-12-08 10:19:50
 * @LastEditors: A21
 * @LastEditTime: 2022-05-17 18:17:56
 * @FilePath: /intell-loan/src/views/pages/publicPage/Perfect/components/tabInfoAuthentication/index.vue
-->
<template>
  <div class="PasswordLogin">
    <v-form
      v-model="fapi"
      :conponentsList="conponentsList"
      :rule="configList"
    />
    <!-- <p
      class="bottom-info"
      v-show="isShow"
    >您授权我们收集您的身份认证信息（姓名、身份证号码、手机号）及您绑定企业基本信息进行身份认证，并委托我们推送给{{bankName}}用于进件审核。</p> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Contract from '@/components/Contract.vue';
import ContractFold from '@/components/ContractFold.vue';
import XydContractGroup from '@/components/XydContractGroup.vue';
import Separator from '@/components/Separator.vue';
import BWSelect from '../common/BWSelect.vue';
import Input from '../common/Input.vue';
import SubmitButton from '../common/SubmitButton.vue';
import NextButton from '../common/NextButton.vue';
import SelectInput from '../common/SelectInput.vue';
import ApplicationType from '../common/ApplicationType.vue';
import VerificationCode from '../common/VerificationCode.vue';

export default {
  name: 'tabInfoAuthentication',
  props: {
    configList: {
      type: Array,
      default: () => [],
    },
    perfectOrderInfo: {},
    bankName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      conponentsList: [BWSelect, Input, SelectInput, ApplicationType, Contract, ContractFold, XydContractGroup, SubmitButton, NextButton, VerificationCode, Separator],
      fapi: {},
      isShow: true,
    };
  },
  provide() {
    return {
      root: this,
    };
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.fapi.onFinishFailed(() => {
      if (!this.fapi.passThrough) {
        const obj = this.fapi.getState();
        this.$emit('input', obj);
        this.updateState({
          submitInfoAll: {
            ...this.publicPage.submitInfoAll,
            ...obj,
          },
        });
      } else {
        this.$emit('input', null);
      }
    });

    // 安卓系统absolute元素兼容
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
      const IH = window.innerHeight;
      window.addEventListener('resize', () => {
        if (window.innerHeight < IH) {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      });
    }
  },
  watch: {
    perfectOrderInfo: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.fapi.setInitialValues(val);
        }
      },
    },
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
  },
};
</script>
<style scoped>
.bottom-info {
  position: absolute;
  bottom: 50px;
  font-size: 13px;
  color: #b3b5b7;
  padding: 16px;
  text-align: left;
  pointer-events: none;
}
</style>
